<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#333">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ get_report.new ? "Novo report" : get_report.nome }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Gerencie os detalhes abaixo
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="get_report._id">
              <v-btn
                color="red"
                @click="excluir_report_dialog(get_report)"
                outlined
                small
                >Excluir</v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </transition>
      </div>
    </v-flex>
    <div class="windows-style-content expande-horizontal wrap">
      <v-flex xs12>
        <v-form ref="form">
          <v-flex class="px-7" xs12>
            <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
              Nome
            </span>
            <v-text-field
              v-model="get_report.nome"
              dense
              solo
              flat
              outlined
              clearable
              :color="$theme.primary"
              :rules="[v => !!v || 'Preencha este campo']"
              label="ex: Roberto"
            ></v-text-field>
          </v-flex>

          <v-flex class="px-7" xs12>
            <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
              Email
            </span>
            <v-text-field
              v-model="get_report.email"
              dense
              solo
              flat
              outlined
              clearable
              :color="$theme.primary"
              label="ex: meuemail@gmail.com"
            ></v-text-field>
          </v-flex>

          <div class="expande-horizontal">
            <v-flex class="px-7" xs6>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                CPF
              </span>
              <v-text-field
                v-model="get_report.cpf"
                dense
                solo
                flat
                outlined
                v-mask="['###.###.###-##']"
                clearable
                :color="$theme.primary"
                label="ex: 000.000.000-00"
              ></v-text-field>
            </v-flex>
          </div>

          <div class="expande-horizontal">
            <v-flex class="px-7" xs6>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Telefone
              </span>
              <v-text-field
                v-model="get_report.telefone"
                dense
                solo
                flat
                outlined
                v-mask="['(##) # #### ####']"
                clearable
                :color="$theme.primary"
                label="ex: (96) 9 8419-6827"
              ></v-text-field>
            </v-flex>
          </div>
          <v-flex class="px-7" xs6>
            <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
              Nascimento
            </span>
            <v-text-field
              v-model="get_report.data_nascimento"
              dense
              solo
              flat
              outlined
              v-mask="['##/##/####']"
              clearable
              :color="$theme.primary"
              label="ex: 12/12/1984"
            ></v-text-field>
          </v-flex>
        </v-form>
      </v-flex>
    </div>

    <div class="expande-horizontal">
      <v-btn large dark @click="valida_form" tile block color="green">
        <span class="fonte"> Salvar </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_report", "getLoggedUser"])
  },
  methods: {
    ...mapActions([
      "criar_report",
      "atualizar_report",
      "fecha_modal_view_report",
      "createConfirmAction"
    ]),
    excluir_report_dialog() {
      this.createConfirmAction({
        message: "Deseja realmente excluir este report?",
        color: "red",
        action: 'excluir_report',
        action_value: { _id: this.get_report._id }
      });
    },
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_report._id ? this.atualizar_report() : this.criar_report();
      }
    },
    backToList() {
      this.$store.commit("set_report", {});
      this.$forceUpdate();
    }
  }
};
</script>
